import { atom } from 'recoil'

export const searchCriteriaOptionsState = atom({
  key: 'rcs_searchCriteriaOptionsState',
  default: {
    groups: [],
    filters: []
  }
})

export const searchCriteriaState = atom({
  key: 'rcs_searchCriteriaState',
  default: {
    loading: false,
    loaded: false,
    error: false,
    severity: 'danger',
    includeGroups: [],
    excludeGroups: [],
    selectedFilters: [],
    typeAppliedFilters: 'All',
    isNewSerach: false
  }
})
